(function() {
    window.c24.lp.ac.cta = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('cta');

            const loginEle = $('.mod24ac.cta .c24Button.js24OpenLoginLayer[data-login-upon-load=1]').first();
            if (!window.c24LpIsApp && loginEle?.length > 0) {
                window.c24LpFrameJsReady.then(() => window.c24OpenLoginLayer(null, loginEle));
            }
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.cta.init();
    });
})();
